import { Component, OnInit, AfterViewInit } from "@angular/core";
import { CclNavbarFooterService, CclMessageService, CclDrawerService, CclRouteTab } from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Subscription } from "rxjs";
import { cloneDeep } from "lodash";
import { EventService } from "../../../../../modules/shared/services/event.service";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";

@Component({
    selector: "app-login-page",
    templateUrl: "./login-page.view.html",
    styleUrls: []
})
export class LoginPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit {
    subscription: Subscription;
    baseUrl: string;
    loginConfigObj: any;
    loginConfig: any = {};
    forms: any = [];
    loginFontStyle: any = {};
    hoverOut: boolean = false;
    hover: boolean = false;
    sessionExpireFontStyle: any = {};

    constructor(
        public sharedService: SharedService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService,
        private catalogService: CatalogService,
        private drawerService: CclDrawerService,
        private eventService: EventService
    ) {
        super(sharedService);
        this.baseUrl = "login";
        sharedService.sessionUrl = this.baseUrl;

        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveloginConfig(message));
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.eventService.getEventSSOList(this.sharedService.event.id).subscribe((resp) => {
            this.sharedService.ssoList.data = resp.body["SSOEventConfigDTOList"];
            this.sharedService.ssoList.data.forEach((element) => {
                element.ssoAccountConfig.buttonConfig = JSON.parse(element.ssoAccountConfig.buttonConfig);
                element.name = element["ssoAccountConfig"]["ssoConfig"]["name"];
            });
        });

        this.eventService.getEventAvailableRegStatusList(this.sharedService.event.id).subscribe((resp) => {
            let responseData: any = [];
            resp.body["data"].forEach((element, index) => {
                const obj = {};
                obj["id"] = element.id;
                obj["name"] = element.name;
                obj["orderIndex"] = index + 1;
                responseData.push(obj);
            });

            this.sharedService.regStatusesList.data = responseData;
        });

        this.eventService.getFormsByUUID(this.sharedService.eventUUID, 20).subscribe((resp) => {
            this.forms = resp.body["formDTOList"];
        });

        this.sharedService.currentLayoutSection = "login";
        this.loginConfigObj = this.sharedService.configs[this.sharedService.configTypes.LOGIN_POPUP];
        if (this.loginConfigObj == null || this.loginConfigObj.id == null) {
            this.loginConfig = cloneDeep(this.sharedService.loginConfig);
            this.loginConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.LOGIN_POPUP
            };
        } else {
            this.loginConfig = JSON.parse(this.loginConfigObj.config);
            if (!this.loginConfig.hasOwnProperty("isEnabled")) {
                this.loginConfig["isEnabled"] = true;
            }
            this.loginFontStyle = {
                color: this.loginConfig.header.label_color,
                "font-style": this.loginConfig.header.fontStyle,
                "text-decoration": this.loginConfig.header.fontStyle,
                "font-weight":
                    this.loginConfig.header.fontStyle != "bold" ? "normal" : this.loginConfig.header.fontStyle
            };
        }

        if(!this.loginConfig.hasOwnProperty("sessionExpiredConfig") || !this.loginConfig.sessionExpiredConfig) {
            this.loginConfig.sessionExpiredConfig = {
                'header': {
                    'label': 'User Session Expired',
                    'label_color': '#FBFBFB',
                    'background': '#0d2958',
                    'fontStyle': 'normal'
                },
                'body': {
                    'background': '#FBFBFB',
                    'text': '<div><p>Your session has expired due to inactivity.</p><p>Please log in again to continue <strong>OR</strong> follow these steps:</p><ol><li>Open your invitation email</li><li>Click the access link</li></ol></div>'
                },
                'footer': {
                    'background': '#FBFBFB',
                    'button': {
                        'primary': {
                            'isPrimaryEnabled': true,
                            'label': 'Go to Login',
                            'background': '#0d2958',
                            'color': '#FBFBFB'
                        }
                    }
                }
            }
        }
        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.loginConfig);
        this.sharedService.changedData = this.loginConfig;
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define My Session & My Schedule Drawer";
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-login";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-login";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    saveloginConfig(message) {
        if (message.text == "save-login" || message.text == "save-next-login") {
            this.loginConfigObj.config = JSON.stringify(this.loginConfig);
            this.catalogService.saveSetupConfig(this.loginConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.createCss(this.catalogService);
                this.sharedService.originalData = cloneDeep(this.loginConfig);
                this.sharedService.changedData = this.loginConfig;

                this.loginConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                this.sharedService.configs[this.sharedService.configTypes.LOGIN_POPUP] = this.loginConfigObj;
                this._flashMessagesService.show("Log In Screen saved successfully.", {
                    cssClass: "alert-success"
                });
                if (message.text == "save-next-login") {
                    this.sharedService.currentLayoutSection = "mysession";
                    this.sharedService.catalogNavigateHelper("admin", "catalog/layout/mysession");
                }
            });
        } else if (message.text == "apply-login-config") {

            // Validate Allowed Registration Status values in After Login Tab.
            if (this.sharedService.currentDrawer?.title === 'Login Body') {
                let areRegStatusAllowed = true;
                let bodyConfig = this.sharedService.loginConfig.body;
                if (Array.isArray(bodyConfig.regStatusConfigs) && !!bodyConfig.regStatusConfigs.length) {
                    bodyConfig.changeRegStatusConfigs?.forEach((changeRegStatus) => {
                        if (areRegStatusAllowed &&
                                !bodyConfig.regStatusConfigs.find((regStatus) => regStatus.id == changeRegStatus.id)) {
                            areRegStatusAllowed = false;
                        }
                    });

                    if (areRegStatusAllowed && bodyConfig.changeRegStatus && !bodyConfig.regStatusConfigs.find(
                            (regStatus) => regStatus.orderIndex == bodyConfig.changeRegStatus)) {
                        areRegStatusAllowed = false;
                    }
                }

                // SCM-52036 :Session Catalog _ pre-filter changes moved to backlog
                // After login pre-filter related changes
                // if(bodyConfig.showAfterLoginPreFilter && bodyConfig.preFilterConfig > 0) {
                //     bodyConfig.preFilterConfigs = [];
                //     this.sharedService.allowedPreFiltersList?.forEach((filter) => {
                //         if(filter.orderIndex == bodyConfig.preFilterConfig) {
                //             bodyConfig.preFilterConfigs.push(filter);
                //         }
                //     });
                // } else {
                //     bodyConfig.preFilterConfig = "Pre-filter";
                //     bodyConfig.preFilterConfigs = [];
                // }

                if (!areRegStatusAllowed) {
                    this._flashMessagesService.show("Allowed Registration Status doesn't match with values in After Login tab.", {
                        cssClass: "alert-danger"
                    });
                    return;
                }
            }

            this.loginConfig = cloneDeep(this.sharedService.loginConfig);
            // For checking unsaved data
            this.sharedService.changedData = this.loginConfig;
            this.loginFontStyle = {};
            setTimeout(() => {
                this.loginFontStyle = {
                    color: this.loginConfig.header.label_color,
                    "font-style": this.loginConfig.header.fontStyle,
                    "text-decoration": this.loginConfig.header.fontStyle,
                    "font-weight":
                        this.loginConfig.header.fontStyle != "bold" ? "normal" : this.loginConfig.header.fontStyle
                };
            }, 0);

            this.drawerService.hideDrawer();
        } else if (message.text == "apply-session-expired-config") {

            this.loginConfig = cloneDeep(this.sharedService.loginConfig);
            // For checking unsaved data
            this.sharedService.changedData = this.loginConfig;
            this.sessionExpireFontStyle = {};
            setTimeout(() => {
                this.sessionExpireFontStyle = {
                    color: this.loginConfig.sessionExpiredConfig.header.label_color,
                    "font-style": this.loginConfig.sessionExpiredConfig.header.fontStyle,
                    "text-decoration": this.loginConfig.sessionExpiredConfig.header.fontStyle,
                    "font-weight":
                        this.loginConfig.sessionExpiredConfig.header.fontStyle != "bold" ? "normal" : this.loginConfig.sessionExpiredConfig.header.fontStyle
                };
            }, 0);

            this.drawerService.hideDrawer();
        }
    }

    openConfigDrawer(item, $event, expansionStyle) {
        $event.stopPropagation();
        let url = "";
        this.sharedService.loginConfig = cloneDeep(this.loginConfig);
        this.sharedService.expansionStyle = expansionStyle;
        if (item == "header") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Login Header",
                navLinks: null,
                saveMessage: "apply-login-config"
            };
            url = "config-drawer/login";
        } else if (item == "body") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Login Body",
                navLinks: [
                    new CclRouteTab("Configuration", "login/config"),
                    new CclRouteTab("After Login", "login/after-login")
                ],
                saveMessage: "apply-login-config"
            };
            url = "config-drawer/login";
        } else if (item == "footer_html_text") {
            this.drawerService.toggleDrawer("mid");
            this.sharedService.currentDrawer = {
                title: "Edit Text",
                navLinks: null,
                saveMessage: "apply-login-config"
            };
            url = "config-drawer/login";
        } else if (item == "body_html_text") {
            this.drawerService.toggleDrawer("mid");
            this.sharedService.currentDrawer = {
                title: "Edit Text",
                navLinks: null,
                saveMessage: "apply-login-config"
            };
            url = "config-drawer/login";
        } else if (item == "button") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Edit Buttons",
                navLinks: null,
                saveMessage: "apply-login-config"
            };
            url = "config-drawer/login";
        } else if (item == "session_expired_header") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Session Expired Header",
                navLinks: null,
                saveMessage: "apply-session-expired-config"
            };
            url = "config-drawer/session-expired";
        } else if (item == "session_expired_body") {
            this.drawerService.toggleDrawer("mid");
            this.sharedService.currentDrawer = {
                title: "Edit Body Content",
                navLinks: null,
                saveMessage: "apply-session-expired-config"
            };
            url = "config-drawer/session-expired";
        } else if (item == "session_expired_button") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Edit Buttons",
                navLinks: null,
                saveMessage: "apply-session-expired-config"
            };
            url = "config-drawer/session-expired";
        }
        this.sharedService.navigateToOutlet("drawer", url);
    }

    changeForm(formId) {
        if (this.forms != null) {
            this.forms.forEach((form) => {
                if (form.id == formId) {
                    this.loginConfig.footer.formId = form.id;
                    this.loginConfig.footer.formDTO = form;
                }
            });
        }
    }

    parse(json) {
        return JSON.stringify(json);
    }

    toggleLoginEnable(e) {
        this.loginConfig.isEnabled = !this.loginConfig.isEnabled;
    }
}
